/**
 * Sets size and clears canvas
 *
 * @param {Object} enabledElement  Enabled Element
 * @param {Object} image Image to be rendered
 * @returns {void}
 * @memberof rendering
 */
export default function (enabledElement, image) {
  const renderCanvas = enabledElement.renderingTools.renderCanvas;

  // Resize the canvas
  renderCanvas.width = image.width || image.columns;
  renderCanvas.height = image.height || image.rows;

  const canvasContext = renderCanvas.getContext("2d");

  // NOTE - we need to fill the render canvas with white pixels since we
  // control the luminance using the alpha channel to improve rendering performance.
  canvasContext.fillStyle = "white";
  canvasContext.fillRect(0, 0, renderCanvas.width, renderCanvas.height);

  const renderCanvasData = canvasContext.getImageData(
    0,
    0,
    image.width || image.columns,
    image.height || image.rows
  );

  enabledElement.renderingTools.renderCanvasContext = canvasContext;
  enabledElement.renderingTools.renderCanvasData = renderCanvasData;
}
